import { defineStore } from 'pinia';
import stores from '@/stores';
import { delay } from '🔗/utils/utils';

export const createTgMessenger = () =>
    defineStore('tg-messenger', {
        state: () => ({
            base: 'https://t.me/bilboMusicBot/app?startapp='
        }),
        actions: {
            canLogin() {
                return !!window.Telegram.WebApp.initDataUnsafe?.user?.username;
            },
            async getLoginData() {
                if (!window.Telegram?.WebApp) {
                    await delay(1500);
                }

                const tg_init_data = this.getInitData();
                const ref = this.getRef();

                return {
                    tg_init_data,
                    ref
                }
            },
            async init() {
                if (!window.Telegram?.WebApp) {
                    return;
                }

                const tg = window.Telegram.WebApp;
                tg.ready();

                const platform = tg.platform;
                const isMobile = platform === 'ios' || platform === 'android';
                const isDesktop = !isMobile;

                if (isMobile) {
                    // Поведение как раньше
                    tg.expand();

                    try {
                        tg.requestFullscreen();
                    } catch (e) {}

                    tg.disableVerticalSwipes();
                }

                if (isDesktop) {
                    // Фиксированная ширина + запрет resize
                    document.body.classList.add('desktop-miniapp');
                }

                tg.MainButton?.hide();

                // Locale
                this.locale = tg.initDataUnsafe?.user?.language_code;

                // Theme
                this.theme = tg.colorScheme;

                this.updateMsgrColors();
            },
            share({ url, message }) {
                if (window.Telegram?.WebApp) {
                    const external_url = `https://telegram.me/share/url?url=${url}&text=${message}`;

                    this.openLink({
                        external_url
                    });
                }
            },
            updateMsgrColors() {
                if (stores.others().theme === 'light') {
                    window.Telegram?.WebApp.setHeaderColor('#ffffff');
                    window.Telegram?.WebApp.setBackgroundColor('#ffffff');
                } else {
                    window.Telegram?.WebApp.setHeaderColor('#121212');
                    window.Telegram?.WebApp.setBackgroundColor('#121212');
                }
            },
            getInitData() {
                return window.Telegram?.WebApp?.initData;
            },
            getDefaultProfileImage() {
                if (!window.Telegram?.WebApp.initDataUnsafe?.user?.photo_url) {
                    return;
                }

                return {
                    resized: window.Telegram?.WebApp.initDataUnsafe.user.photo_url,
                    original: window.Telegram?.WebApp.initDataUnsafe.user.photo_url
                }
            },

            getStartParam() {
                return window.Telegram?.WebApp?.initDataUnsafe?.start_param;
            },
            getRef() {
                let ref = null;

                (window.Telegram.WebApp?.initDataUnsafe?.start_param || '').split('&').forEach(item => {
                    if (item.toLowerCase().includes('ref_')) {
                        ref = item.toLowerCase().split('ref_')[1];
                    }
                });

                return ref;
            },
            openLink({ external_url, type, target }) {
                if (window.Telegram?.WebApp) {
                    if (type === 'telegram') {
                        window.Telegram?.WebApp.openTelegramLink(external_url);
                    } else {
                        if (target) {
                            window.open(external_url, target);
                        } else {
                            window.Telegram?.WebApp.openLink(external_url);
                        }
                    }
                } else {
                    window.open(external_url, '_blank');
                }
            },
            showBackButton(back) {
                const button = window.Telegram?.WebApp?.BackButton;
                if (!button) {
                    return;
                }

                if (button.isVisible) {
                    return;
                }

                button.show();
                window.Telegram?.WebApp.onEvent('backButtonClicked', back);
            },
            hideBackButton(back) {
                const button = window.Telegram.WebApp?.BackButton;
                if (!button) {
                    return;
                }

                if (!button.isVisible) {
                    return;
                }

                window.Telegram?.WebApp.offEvent('backButtonClicked', back);
                button.hide();
            },
            showSettingsButton(callback) {
                const button = window.Telegram.WebApp?.SettingsButton;
                if (!button) {
                    return;
                }

                if (button.isVisible) {
                    return;
                }

                button.show();
                window.Telegram?.WebApp.onEvent('settingsButtonClicked', callback);
            },
            hideSettingsButton(callback) {
                const button = window.Telegram.WebApp?.SettingsButton;
                if (!button) {
                    return;
                }

                if (!button.isVisible) {
                    return;
                }

                button.hide();
                window.Telegram?.WebApp.offEvent('settingsButtonClicked', callback);
            },
            vibrate(mode) {
                const hf = window.Telegram?.WebApp?.HapticFeedback;

                if (!hf) {
                    return;
                }

                if (['success', 'warning', 'error'].indexOf(mode) !== -1) {
                    hf.notificationOccurred(mode);
                    return;
                }

                hf.impactOccurred(mode || 'light');
            }
        }
    });
